import React from "react";
import { Maximize2, Cpu, MonitorPlay, Network, Lightbulb, SlidersHorizontal, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const solutions = [{
  title: "Infrastruttura Digitale",
  description: "Sviluppo ecosistemi B2B e Cyber Security Anti-Ransomware. [SUBENTRO TECNOLOGICO & DIGITAL RESCUE]",
  icon: Cpu
}, {
  title: "Espansione Globale",
  description: "Market Entry e Matchmaking d'Élite via Network Geroi.it. [DIVISIONE VOSTOKA: ACCESSO SU INVITO]",
  icon: Network
}, {
  title: "Logistica Industriale",
  description: "Spedizioni End-to-End e Supply Chain globale. [ACCESSO A CORRIDOI DOGANALI RISERVATI]",
  icon: Maximize2
}, {
  title: "Cyber Security",
  description: "Protezione blindata degli asset critici e intelligence offensiva per la salvaguardia del capitale.",
  icon: SlidersHorizontal
}, {
  title: "Network Strategico",
  description: "Accesso privilegiato a capitali CSI e mercati dell'Est attraverso canali diplomatici privati.",
  icon: Lightbulb
}, {
  title: "Automazione AI",
  description: "Integrazione di intelligenza artificiale di grado industriale per l'ottimizzazione dei flussi operativi.",
  icon: MonitorPlay
}];
export default function TechnicalSolutionsEcosystem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="28751" id="i-3-pilastri-operativi" className="bg-[#0A0A0A] py-24 relative overflow-hidden dark">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
        <div className="absolute -top-[20%] -right-[10%] w-[600px] h-[600px] rounded-full bg-[#DC143C] blur-[120px]" />
        <div className="absolute top-[40%] -left-[10%] w-[400px] h-[400px] rounded-full bg-[#E6D5B8] blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-[#E6D5B8] font-serif font-medium tracking-[0.2em] uppercase text-sm mb-3">
            ARCHITETTURA DI POTERE
          </h2>
          <h3 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6 tracking-tight uppercase">
            I 3 Pilastri Operativi
          </h3>
          <p className="text-lg font-sans text-white/70 leading-relaxed">
            Non costruiamo semplici siti. Forgiamo infrastrutture blindate, sblocchiamo corridoi logistici riservati e scaliamo fatturati su scala globale.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {solutions.map((solution, i) => <div key={i} data-index={i} className="h-full">
              <Card className="group h-full bg-white/[0.03] backdrop-blur-xl border-white/10 hover:border-[#E6D5B8]/40 hover:shadow-[0_0_30px_rgba(230,213,184,0.1)] transition-all duration-500 cursor-default rounded-none">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-none bg-white/5 text-[#E6D5B8] group-hover:bg-[#DC143C] group-hover:text-white transition-colors duration-500">
                    <solution.icon className="w-7 h-7 group-hover:scale-110 transition-transform duration-500" strokeWidth={1} />
                  </div>
                  <CardTitle className="text-2xl font-serif font-semibold text-white group-hover:text-[#E6D5B8] transition-colors duration-500 uppercase tracking-wide">
                    {solution.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base font-sans leading-relaxed text-white/60 group-hover:text-white/80 transition-colors duration-500">
                    {solution.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-none px-10 py-8 bg-[#DC143C] hover:bg-[#B01030] text-white font-serif text-xl tracking-wider transition-all duration-300">
            <Link to="/HomePage">
              RICHIEDI AUDIT DI SALVATAGGIO
              <ArrowRight className="ml-3 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}